import 'css-chunksrc/client/scenes/milestoneCreation/styles.scss';export default {
  "milestoneCreation": "_milestoneCreation_1qmu8_1",
  "main": "_main_1qmu8_10",
  "buttons": "_buttons_1qmu8_21"
};